module.exports = __webpack_public_path__ + "img/ico_folder--wh.e0cf569a.svg";